/**
 * @module api/gateway-service
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const API_GATEWAY_CONSTANTS = {
  BODY: '_body',
  EMPTY: '',
  WEB: 'web',
  NRD: 'nrd',
};
